import React, { useState } from 'react';
import { Row, Col, Input, Form, Select, DatePicker, Card } from 'antd';
import styles from './index.module.css';
import WeekStay from './WeekStay';
import TextArea from '../../../../ui/TextArea';
const { RangePicker } = DatePicker;
const Option = Select.Option;
const BALANCEOFSTAY = 'Charge (Balance of Stay)';
interface weekStayType {
  title: string;
  firstName: string;
  secondName: string;
}
const weekStayData = [
  {
    title: 'Sunday',
    firstName: 'sundaymin',
    secondName: 'sundaymax',
  },
  {
    title: 'Monday',
    firstName: 'mondaymin',
    secondName: 'mondaymax',
  },
  {
    title: 'Tuesday',
    firstName: 'tuesdaymin',
    secondName: 'tuesdaymax',
  },
  {
    title: 'Wednesday',
    firstName: 'wednesdaymin',
    secondName: 'wednesdaymax',
  },
  {
    title: 'Thursday',
    firstName: 'thursdaymin',
    secondName: 'thursdaymax',
  },
  {
    title: 'Friday',
    firstName: 'fridaymin',
    secondName: 'fridaymax',
  },
  {
    title: 'Saturday',
    firstName: 'saturdaymin',
    secondName: 'saturdaymax',
  },
];
const MinAndMaxStayItem = (props: { index: number }) => {
  return (
    <Card>
      <Row gutter={24}>
        <Col
          span={12}
          className="col-margin"
        >
          <Form.Item
            name={[`${props.index}`, 'dateRange']}
            label="Start Date ~ End Date"
            rules={[{ required: true, message: 'This field is required' }]}
          >
            <RangePicker format="YYYY/MM/DD" />
          </Form.Item>
        </Col>
        <Col
          span={6}
          className="col-margin"
        >
          <Form.Item
            name={[`${props.index}`, 'rulenumber']}
            label="Rule Number"
            rules={[
              { required: false, message: 'This field is required' },
              {
                pattern: /^\d{1,5}(\.\d*)?$/,
                message: 'This field should be a number',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col
          span={18}
          className="col-margin"
        >
          <Form.Item
            name={[`${props.index}`, 'ruledescription']}
            label="Rule Descriptions"
            rules={[
              { required: true, message: 'This field is required' },
              {
                max: 19,
                message: 'You have reached the max character length of 19',
              },
            ]}
          >
            <TextArea
              maxLength={19}
              autoSize={{ minRows: 3, maxRows: 5 }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={2}></Col>
        <Col span={3}>Minimum Stay</Col>
        <Col span={2}></Col>
        <Col span={3}>Maximum Stay</Col>
      </Row>
      <Row
        gutter={24}
        className={styles['min-and-max-stay-margin']}
      >
        <Col span={2}></Col>
        <Col span={3}>
          <span className={styles['min-and-max-color']}>(1-35)</span>
        </Col>
        <Col span={2}></Col>
        <Col span={3}>
          <span className={styles['min-and-max-color']}>(1-255)</span>
        </Col>
      </Row>
      {weekStayData.map((item: weekStayType, i: number) => (
        <WeekStay
          dataSource={item}
          index={props.index}
          key={i}
        />
      ))}
    </Card>
  );
};

export default MinAndMaxStayItem;
